import { motion } from "framer-motion";

const baseVariants = {
    hidden: { opacity: 0, y: 28 },
    visible: (i = 0) => ({
        opacity: 1,
        y: 0,
        transition: {
            delay: i * 0.08,
            duration: 0.8,
            ease: [0.22, 1, 0.36, 1],
        },
    }),
};

/**
 * Wraps any element with a scroll-triggered fade + lift reveal.
 * Props: as ('div' | 'section' | 'h1'...), delay (number), className, children, ...rest
 */
export default function SectionReveal({
    as: Tag = "div",
    delay = 0,
    className = "",
    children,
    once = true,
    amount = 0.2,
    y = 28,
    ...rest
}) {
    const MotionTag = motion[Tag] || motion.div;
    return (
        <MotionTag
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once, amount }}
            transition={{
                delay,
                duration: 0.85,
                ease: [0.22, 1, 0.36, 1],
            }}
            className={className}
            {...rest}
        >
            {children}
        </MotionTag>
    );
}

export const staggerContainer = {
    hidden: {},
    visible: {
        transition: { staggerChildren: 0.12, delayChildren: 0.05 },
    },
};

export const staggerItem = baseVariants;
